// extracted by mini-css-extract-plugin
module.exports = {"root":"DonationOptionVerticalTile_root__dAyJ4"};